import Constants from '../actions/types';

const initialState = {
  roles: [],
  loading: false,
  message: null,
  severity: null
};

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.ROLES_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.ROLES_GET_SUCCESS: {
      const newState = {
        ...state,
        roles: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ROLES_GET_FAILURE: {
      const newState = {
        ...state,
        roles: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.ROLES_ADD_SUCCESS: {
      const newRoles = [...state.roles, action.payload];
      const newState = {
        ...state,
        roles: newRoles,
        loading: false,
        message: 'The role was added successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.ROLES_DELETE_SUCCESS: {
      const selectedRole = state.roles.find(
        role => role.id === action.payload.id
      );
      const index = state.roles.indexOf(selectedRole);
      const newRoles = [].concat(
        state.roles.slice(0, index),
        state.roles.slice(index + 1)
      );
      const newState = {
        ...state,
        roles: newRoles,
        loading: false,
        message: 'The role was deleted successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.ROLES_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.ROLES_SAVE_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        message: 'The role was saved successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.ROLES_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.ROLES_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default rolesReducer;
